// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileInput_container__VbpnR {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
}

.FileInput_input-container__hKhMm {
  height: 40px;
  border: solid 1px #666666;
  border-radius: 4px;
  margin-top: 8px;
  padding: 9px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.FileInput_file-picker-container__QknXi {
  color: #666666;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.FileInput_input__NFbIN {
  display: none;
}

.FileInput_input-error__J3WT- {
  border: solid 1px #c9423c;
}

.FileInput_error-text__CSxyP {
  margin-top: 10px;
  color: #c9423c;
  font-size: 12px;
}

.FileInput_file__1qqOz {
  color: #054ab0;
  font-size: 13px;
}

.FileInput_file-picker__Ox4SI {
  color: #ff6b00;
  float: right;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/FileInput/FileInput.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,gBAAA;EACA,cCjBM;EDkBN,eEvCO;AFsCT;;AAIA;EACE,cCzCO;ED0CP,eAAA;AADF;;AAIA;EACE,cC7CQ;ED8CR,YAAA;EACA,eAAA;AADF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n.container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 18px;\n}\n\n.input-container {\n  height: 40px;\n  border: solid 1px #666666;\n  border-radius: 4px;\n  margin-top: 8px;\n  padding: 9px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.file-picker-container {\n  color: #666666;\n  font-size: 13px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.input {\n  display: none;\n}\n\n.input-error {\n  border: solid 1px colors.$error;\n}\n\n.error-text {\n  margin-top: 10px;\n  color: colors.$error;\n  font-size: typography.$body-s;\n}\n\n.file {\n  color: colors.$accent;\n  font-size: 13px;\n}\n\n.file-picker {\n  color: colors.$primary;\n  float: right;\n  cursor: pointer;\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FileInput_container__VbpnR`,
	"input-container": `FileInput_input-container__hKhMm`,
	"file-picker-container": `FileInput_file-picker-container__QknXi`,
	"input": `FileInput_input__NFbIN`,
	"input-error": `FileInput_input-error__J3WT-`,
	"error-text": `FileInput_error-text__CSxyP`,
	"file": `FileInput_file__1qqOz`,
	"file-picker": `FileInput_file-picker__Ox4SI`
};
export default ___CSS_LOADER_EXPORT___;
